import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

export const Route = createFileRoute("/imports")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Bring in your photos",
    "Connect Facebook and Google Photos to bring years of family photos into Memily, then choose what to keep and share. We're building this surface now.",
  ),
});
